import { forwardRef } from "react";

/**
 * Un botón de la cabecera: un icono, una cosa.
 *
 * El contador va DENTRO del botón y con su número. El diseño anterior ponía un
 * punto de 12 px sin cifra pegado al avatar, así que un aviso y cuarenta se
 * veían exactamente igual —y el número ya existía en el código, sólo no se
 * pintaba—. A partir de 99 se escribe «99+»: el ancho del botón es fijo y un
 * número de cuatro cifras lo deformaría sin decir nada más útil.
 */

interface Props {
  icono: string;
  etiqueta: string;
  activo?: boolean;
  onClick: () => void;
  cuenta?: number;
  /** Marca el botón en el DOM para que otro árbol pueda anclarse a él. */
  ancla?: string;
}

const BotonDeCabecera = forwardRef<HTMLButtonElement, Props>(function BotonDeCabecera(
  { icono, etiqueta, activo = false, onClick, cuenta = 0, ancla },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      data-ancla-menu={ancla}
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={activo}
      aria-label={cuenta > 0 ? `${etiqueta} (${cuenta})` : etiqueta}
      title={etiqueta}
      /*
        44 px donde se toca con el dedo, 36 donde hay cursor. Medido: a
        390 px estos tres salían de 36, que es menos de lo que un dedo
        acierta sin fallar al de al lado.
      */
      className={`relative flex h-11 w-11 items-center justify-center rounded-full transition-colors md:h-9 md:w-9 ${
        activo
          ? "bg-subtle text-content"
          : "text-content-muted hover:bg-subtle hover:text-content-secondary"
      }`}
    >
      <i className={`${icono} text-[18px]`} aria-hidden="true" />
      {cuenta > 0 && (
        <span className="hud-dato absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-error px-1 text-[9px] font-bold leading-none text-white ring-2 ring-surface">
          {cuenta > 99 ? "99+" : cuenta}
        </span>
      )}
    </button>
  );
});

export default BotonDeCabecera;
